import { render, staticRenderFns } from "./studioListDetail.vue?vue&type=template&id=b64f1f00&scoped=true"
import script from "./studioListDetail.vue?vue&type=script&lang=js"
export * from "./studioListDetail.vue?vue&type=script&lang=js"
import style0 from "./studioListDetail.vue?vue&type=style&index=0&id=b64f1f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64f1f00",
  null
  
)

export default component.exports